<template>
  <div class="results platform">
      <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("nav.platform") }} </BreadcrumbItem>
      </Breadcrumb>
    </div>

    <div class="results-wrap">
      <div class="headtitle">平台服务</div>
      <div class="s1">
        <div class="s1Wrap">
          <Row :gutter="60" type="flex">
            <Col span="6" class="p1">
              <div class="wrap">
                <img src="~@/assets/images/pl/1.png" alt="">
                <div class="title">政务赋能</div>
              </div>
            </Col>
            <Col span="9" class="p2">
              <div class="wrap">可为政府做决策参考，对全省的宏观利用情况以及特定产业、特定商品、特定区域的利用率做分析。</div>
            </Col>
            <Col span="9" class="p3">
              <div class="wrap">
                <div class="item">智能指引RCEP应用</div>
                <div class="item">政府RCEP贸易看板</div>
                <div class="item">产业园区招商引资辅助决策</div>
                <div class="item">区内企业关税享惠普及应尽享RCEP红利</div>
                <div class="item">跨境合规公共查询服务</div>
              </div>
            </Col>
          </Row>
        </div>
        <div class="s1Wrap">
          <Row :gutter="60" type="flex">
            <Col span="6" class="p1">
              <div class="wrap">
                <img src="~@/assets/images/pl/2.png" alt="">
                <div class="title">企业赋能</div>
              </div>
            </Col>
            <Col span="9" class="p2">
              <div class="wrap">帮助企业了解、掌握关税减让和享惠规则，为企业应用协定优惠应享尽享打好基础。同时，聚焦RCEP实施过程中可能出现的难点，帮助企业提前做好准备。</div>
            </Col>
            <Col span="9" class="p3">
              <div class="wrap">
                <div class="item">推荐最优享惠方案</div>
                <div class="item">原产地申领及管理</div>
                <div class="item">“经核准出口企业”申请辅导</div>
                <div class="item">提供关税享惠分析报告</div>
                <div class="item">企业享惠合规线上体检</div>
              </div>
            </Col>
          </Row>
        </div>
        <div class="s1Wrap">
          <Row :gutter="60" type="flex">
            <Col span="6" class="p1">
              <div class="wrap">
                <img src="~@/assets/images/pl/3.png" alt="">
                <div class="title">人才赋能</div>
              </div>
            </Col>
            <Col span="9" class="p2">
              <div class="wrap">在合规人才稀缺的当下，帮助行业进行人才培养，为企业输送专业合规人才。</div>
            </Col>
            <Col span="9" class="p3">
              <div class="wrap">
                <div class="item">外贸人跨境合规助手</div>
                <div class="item">关税专业人才系列课程</div>
                <div class="item">联合专业机构人才认证体系</div>
                <div class="item">为企业线上推荐关务人才</div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s2">
        <div class="s2Wrap">
          <Row :gutter="100" type="flex">
            <Col span="12">
              <div class="wrap">
                <img src="~@/assets/images/pl/s11.png" alt="">
                <div class="info">
                  <div class="title" style="color:#01c6f4">海关税率查询</div>
                  <div class="desc">帮助外贸企业了解海外税率情况，合理整合优化供应链及运输路由，以获得更有竞争力的贸易模式。</div>
                </div>
              </div>
            </Col>
            <Col span="12">
              <div class="wrap">
                <img src="~@/assets/images/pl/s12.png" alt="">
                <div class="info">
                  <div class="title" style="color:#4472c4">原产地预判及申领辅助</div>
                  <div class="desc">为企业提供信息化智能化工具，及可以获知其进出口产品是否满足RCEP协定的原产地规则要求。并可以根据企业提供的信息给出优化方案，帮助其最大程度的利用RCEP优惠关税政策。</div>
                </div>
              </div>
            </Col>
            <Col span="12">
              <div class="wrap">
                <img src="~@/assets/images/pl/s13.png" alt="">
                <div class="info">
                  <div class="title">RCEP最优关税方案</div>
                  <div class="desc">综合分析几十种税率情况，帮助企业获得最优关税方案，帮助企业在进出口时利用优惠税率政策达到降本增效的目的，提升企业综合竞争能力。</div>
                </div>
              </div>
            </Col>
            <Col span="12">
              <div class="wrap">
                <img src="~@/assets/images/pl/s14.png" alt="">
                <div class="info">
                  <div class="title">企业进出口享惠分析</div>
                  <div class="desc">利用企业提供的历史贸易数据，让企业管理层可以一目了然的获知RCE[优惠政策可以为其带来的成本减免红利，并汇总成分析报告让企业未来可以更直观更深入的用好RCEP优惠政策。</div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <ZX></ZX>
    </div>
  </div>
</template>

<script>
import ZX from '@/components/layout/ZX'

export default {
  name: 'HelpPlatform',
  components: { ZX },
}
</script>

<style scoped>
.results{
  position: relative;
  padding: 15px 0 25px;
}
.results-wrap{
  width:1400px;
  margin: 0 auto;
  padding-bottom: 20px;
  max-width: var(--contentPageMaxWidth);
}
.headtitle{
  font-size: 2.6rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
}
.s1 {
  margin-top: 40px;
}
.s1 .s1Wrap{
  margin-bottom: 40px;
}
.s1 .s1Wrap:last-child{
  margin-bottom: 0;
}
.s1 .p1{
  display: flex;
  align-items: center;
  justify-content: center;
}
.s1 .p1 img{
  width: 80px;
  display: block;
  margin: 0 auto 20px;
}
.s1 .p1 .title{
  font-size: 2.4rem;
  font-weight: bold;
  text-align: center;
  color: #333;
}
.s1 .p2, .s1 .p3{
  font-size: 16px;
  line-height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.s1 .p2 .wrap{
  /* text-indent: 26px; */
  text-align: justify;
}
.s1 .p3{
  justify-content: flex-start;
}
.s1 .p3 .wrap{
  padding-left: 30px;
}
.s1 .p3 .item{
  background: url("~@/assets/images/pl/arrow.jpg") 0 center no-repeat transparent;
  background-size: 18px;
  padding-left: 26px;
  margin-bottom: 10px;
  color: #ffa000;
}
.s1 .p3 .item:last-child{
  margin-bottom: 0;
}
.s2{
  margin-top: 70px;
}
.s2 >>> .ivu-col{
  padding-bottom: 30px;
}
.s2 .wrap{
  position: relative;
  padding-left: 100px;
  padding-right: 20px;
}
.s2 img{
  width: 60px;
  position: absolute;
  left: 20px;
  top: 10px;
}
.s2 .info .title{
  font-size: 18px;
  font-weight: bold;
  line-height: 32px;
  margin-bottom: 5px;
  color: #ffa000;
}
.s2 .info .desc{
  font-size: 16px;
  line-height: 26px;
  text-align: justify;
}
</style>

<style>
@media print,screen and (min-width:2300px) {
  .platform .headtitle{
    font-size: 3rem;
  }
  .platform .s1 .p1 .title{
    font-size: 2.6rem;
  }
  .platform .s1 .p2, .platform .s1 .p3{
    font-size: 18px;
  }
  .platform .s2 .info .title{
    font-size: 18px;
  }
  .platform .s2 .info .desc{
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help/Platform.vue